jQuery( document ).ready(function($) { 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '992',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });
  var $allVideos = $("iframe[src*='www.youtube.com'],iframe[src*='youtube-nocookie.com'],iframe[src*='player.vimeo.com']");

	$allVideos.each(function() {
		$(this).data('aspectRatio', this.height / this.width).removeAttr('height').removeAttr('width');
	});

	$(window).resize(function() {
		$allVideos.each(function() {
		  var $el = $(this);
		  var newWidth = $el.parent().width();
		  $el.width(newWidth).height(newWidth * $el.data('aspectRatio'));
		});
	}).resize();
});
$('#navigation ul').delay(1000); 
$(window).scroll(function() {

  if ( $(window).scrollTop() >= 50 ) {
      $('.headermenu').addClass("fixedheadermenu");
      $('#LOGO_hypLogoWit').css("display", "none");
			$('#LOGO_hypLogo').css("display", "block");

  } else {
      $('.headermenu').removeClass("fixedheadermenu");
      $('#LOGO_hypLogo').css("display", "none");
			$('#LOGO_hypLogoWit').css("display", "block");
  }
});

